import { purify, theme } from '@vfit/shared/themes';
import { Svg } from '@vfit/shared/atoms';
import { useState } from 'react';
import { ProductCardSpecItemAction } from '../Inflation/inflation.style';
import { I_ConsumerInflationProps } from './consumerInflation.models';
import ConsumerVodafoneModal from '../ConsumerVodafoneModal/consumerVodafoneModal';
import {
  PromotionContainer,
  PromotionDisclaimer,
  PromotionTitle,
  PromotionTitleContainer,
} from '../ConsumerOfferPromotion/consumerOfferPromotion.style';

const ConsumerInflation = ({
  inflationTitle,
  popup,
  color,
  inflationDisclaimer,
  popupTitle,
  tracking,
  isGlobalPromo = false,
  isConsumer = false,
}: I_ConsumerInflationProps) => {
  const [modal, setModal] = useState({
    show: false,
    text: '',
    title: '',
  });

  const [
    purifiedInflationTitle,
    purifiedInflationDisclaimer,
    purifiedModalTitle,
    purifiedModalText,
  ] = purify([
    inflationTitle || '',
    inflationDisclaimer || '',
    modal?.title || '',
    modal?.text || '',
  ]);

  const themeFontWeight = theme.typography.fontWeight;

  const onCloseModal = () => {
    setModal({
      show: false,
      text: '',
      title: '',
    });
  };

  return (
    <>
      <PromotionContainer>
        {purifiedInflationDisclaimer && (
          <PromotionDisclaimer
            dangerouslySetInnerHTML={{
              __html: purifiedInflationDisclaimer,
            }}
          />
        )}

        <PromotionTitleContainer>
          {purifiedInflationTitle && (
            <PromotionTitle
              style={{
                color,
                fontWeight: isGlobalPromo ? themeFontWeight.bold : themeFontWeight.regular,
              }}
              dangerouslySetInnerHTML={{
                __html: purifiedInflationTitle,
              }}
            />
          )}

          {popup && (
            <div
              className="tooltip"
              role="presentation"
              onClick={() => {
                tracking?.();

                setModal({
                  title: popupTitle || inflationTitle || '',
                  text: popup,
                  show: true,
                });
              }}
            >
              <ProductCardSpecItemAction>
                {isConsumer ? <Svg name="info" height={16} width={16} /> : '+'}
              </ProductCardSpecItemAction>
            </div>
          )}
        </PromotionTitleContainer>
      </PromotionContainer>

      <ConsumerVodafoneModal
        isModalShown={modal.show}
        onCloseModal={onCloseModal}
        purifiedModalTitle={purifiedModalTitle}
        purifiedModalText={purifiedModalText}
      />
    </>
  );
};

export default ConsumerInflation;

